import React from 'react';

export default function VirtualizedPlayerGrid({ items, renderCard }) {
  if (items.length === 0) return null;

  return (
    <div className="players-grid">
      {items.map((item) => renderCard(item))}
    </div>
  );
}
